import CustomHead from "../components/CustomHead";
import Homepage from "./homepage";

export default function Index() {
  /*
   * Replace the elements below with your own.
   *
   * Note: The corresponding styles are in the ./index.css file.
   */
  return (
    <>
      <CustomHead
        title="Connect'Events"
        content="Trouve facilement les événements qui t'intéressent, où tu veux, quand tu veux ! Des expositions, des soirées, des salons ou toutes autres manifestations ! Connect’Events te permet de rester connecté aux événements de ta ville et d'ailleurs."
        pageSlug="/"
      />
      <div>
        <Homepage />
      </div>
    </>
  );
}
